export * from './errorStrings';
export * from './firebaseConfig';
export * from './routes';
export * from './sideBar';
export * from './strings';

const ERROR_CODE = {
  FORBIDDEN: 403,
};

const ACCEPT_IMAGES = [
  'image/png',
  'image/jpeg',
  'image/apng',
  'image/avif',
  'image/gif',
  'image/svg+xml',
  'image/webp',
];

// LINE Flexのimageコンポーネントが受け付ける形式（アンケート招待画像等、LINEへ直接送る画像用）
const ACCEPT_LINE_FLEX_IMAGES = ['image/jpeg', 'image/png'];

const ACCEPT_VIDEO = ['video/mp4', 'video/mov', 'video/quicktime'];
const ACCEPT_PDF = ['application/pdf'];
const LIMIT_FILE = 4;
const ONE_MB = 1024 * 1000;
const MAX_FILE_SIZE_PUBNUB = ONE_MB * 5; // 5MB;
const MAX_LINE_IMAGE_SIZE = ONE_MB * 10; // 10MB;
// LINEの動画メッセージ上限200MBに対し安全マージンを取る。
// backend の VIDEO_UPLOAD_MAX_SIZE_BYTES と必ず同一バイト数にすること
const MAX_LINE_VIDEO_SIZE = ONE_MB * 190; // 190MB;
const MAX_PDF_FILE_SIZE = ONE_MB * 10; // 10MB;
const DATE_FORMAT = 'YYYY年M月D日';
const EMPTY_VALUE = '-';
const MEMO_PREVIEW_LENGTH = 20;
const MEMO_MAX_LENGTH = 1000;
const MIN_FRIEND_COUNT = 0;
const DEFAULT_FRIEND_LIMIT = 5;
const LINE_NAME_MAX_LENGTH = 255;
const TAG_NAME_MAX_LENGTH = 50;
const MANAGEMENT_PAGE_SIZE = 20;
const USERS_PAGE_SIZE = MANAGEMENT_PAGE_SIZE;
const CHAT_CHANNELS_PAGE_SIZE = 20;
const CHAT_MESSAGE_SIZE = 25;
const CHAT_SEND_ACTIVE_DEBOUNCE_MS = 1000;
const CHAT_TYPING_TIME_MS = 3000;
const AI_SELECT_LIMIT = 5;
const MAX_BULK_MESSAGE_SECTIONS = 5;

export {
  ACCEPT_IMAGES,
  ACCEPT_LINE_FLEX_IMAGES,
  ACCEPT_PDF,
  ACCEPT_VIDEO,
  AI_SELECT_LIMIT,
  CHAT_CHANNELS_PAGE_SIZE,
  CHAT_MESSAGE_SIZE,
  CHAT_SEND_ACTIVE_DEBOUNCE_MS,
  CHAT_TYPING_TIME_MS,
  DATE_FORMAT,
  DEFAULT_FRIEND_LIMIT,
  EMPTY_VALUE,
  ERROR_CODE,
  LIMIT_FILE,
  LINE_NAME_MAX_LENGTH,
  MANAGEMENT_PAGE_SIZE,
  MAX_BULK_MESSAGE_SECTIONS,
  MEMO_MAX_LENGTH,
  TAG_NAME_MAX_LENGTH,
  MEMO_PREVIEW_LENGTH,
  MIN_FRIEND_COUNT,
  MAX_FILE_SIZE_PUBNUB,
  MAX_LINE_IMAGE_SIZE,
  MAX_LINE_VIDEO_SIZE,
  MAX_PDF_FILE_SIZE,
  ONE_MB,
  USERS_PAGE_SIZE,
};
